import React from 'react';
import PropTypes from 'prop-types';

export default function Row({ children, gutter }) {
  return (
    <div
      className="a-row"
      data-testid="row"
      style={gutter ? { '--row-gutter': gutter } : undefined}
    >
      {children}
    </div>
  );
}

Row.defaultProps = {
  gutter: null,
};

Row.propTypes = {
  children: PropTypes.node.isRequired,
  gutter: PropTypes.string,
};
